import styled from '@emotion/styled';

const enterEasing = 'cubic-bezier(0.0, 0.0, 0.2, 1);';
const exitEasing = 'cubic-bezier(0.4, 0.0, 1, 1)';
const AnimationWrapper = styled('div')`
  /* Slide in from right
     Slide out towards right */
  .fadeRight-enter {
    position: absolute;
    left: 0;
    right: 0;

    opacity: 0;
    z-index: 1;
    transform: translateX(100px);
    transition: all 100ms ${enterEasing};
  }

  .fadeRight-enter.fadeRight-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: all 100ms ${enterEasing};
  }

  .fadeRight-exit.fadeRight-exit-active {
    position: absolute;
    left: 0;
    right: 0;

    opacity: 0;
    transform: translateX(100px);
    transition: all 100ms ${exitEasing};
  }

  /* Slide in from left
     Slide out towards left */
  .fadeLeft-enter {
    position: absolute;
    left: 0;
    right: 0;

    opacity: 0;
    z-index: 1;
    transform: translateX(-100px);
    transition: all 100ms ${enterEasing};
  }

  .fadeLeft-enter.fadeLeft-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: all 100ms ${enterEasing};
  }

  .fadeLeft-exit.fadeLeft-exit-active {
    position: absolute;
    left: 0;
    right: 0;

    opacity: 0;
    transform: translateX(-100px);
    transition: all 100ms ${exitEasing};
  }

  will-change: transform, opacity, position, left, right;
`;

export default AnimationWrapper;
